<div [class.big]='big'>
  <p class="shared-title">{{title}}</p>
  <div class="user-info" *ngFor='let item of sharedWithList | slice:0:5'>
    <img [src]="item.thumbnail | authImage | async" class="user-thumb">
    <label *ngIf="owner" class="user-owner">{{ item.name }}</label>
  </div>
  <div class="user-info" *ngIf='sharedWithList.length > 5'>
    <div class="custom-badge"> + {{ sharedWithList.length - 5}}</div>
  </div>
</div>
